const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.obipumanee.ladyfirst&hl=th';
const APP_SCHEME = 'ladyfirst.me';

const isAndroid = () => /Android/i.test(navigator.userAgent);
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const isMobileDevice = () => isAndroid() || isIOS();

export const getPlayStoreUrl = () => PLAY_STORE_URL;

export const getPublicOrigin = () =>
  process.env.REACT_APP_PUBLIC_APP_ORIGIN || 'https://ladyfirst.me';

export const getProfileWebUrl = (username) =>
  `${getPublicOrigin()}/profile/${encodeURIComponent(username || '')}`;

const buildSchemeUrl = (path) => `${APP_SCHEME}:///${String(path).replace(/^\/+/, '')}`;

const openDeepLink = (path, webFallbackUrl) => {
  if (!isMobileDevice()) {
    window.location.href = webFallbackUrl;
    return;
  }

  window.location.href = buildSchemeUrl(path);

  // If app does not open within 2s, send user to store.
  window.setTimeout(() => {
    if (isAndroid() || isIOS()) {
      window.location.href = PLAY_STORE_URL;
    }
  }, 2000);
};

export const openProfileInAppOrStore = (profileId, usernameForFallback) => {
  const path = `profile/${profileId}`;
  openDeepLink(path, getProfileWebUrl(usernameForFallback));
};

export const openProductInAppOrStore = (productId) => {
  openDeepLink(`products/${productId}`, PLAY_STORE_URL);
};

export const getProfileDeepLinkUrl = (profileId) =>
  buildSchemeUrl(`profile/${encodeURIComponent(profileId)}`);

export const getProductDeepLinkUrl = (productId) =>
  buildSchemeUrl(`products/${encodeURIComponent(productId)}`);
